import { render, staticRenderFns } from "./TreatmentCardVersion.vue?vue&type=template&id=55b7a702&scoped=true"
import script from "./TreatmentCardVersion.vue?vue&type=script&lang=js"
export * from "./TreatmentCardVersion.vue?vue&type=script&lang=js"
import style0 from "./TreatmentCardVersion.vue?vue&type=style&index=0&id=55b7a702&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "55b7a702",
  null
  
)

export default component.exports